import { ProductDonationRecurrenceInterval } from "@simplyk/common";

import { getEnabledFrequencies } from "./donationFrequencies";

import {
  StepSuggestedDonationAmountsFormData,
  UpdateSuggestedAmountsToSaveInput,
} from "@/features/LiveFormEditor/Steps/StepSuggestedDonationAmounts/types";

export const getAmountsToSave = ({
  formData,
}: {
  formData: StepSuggestedDonationAmountsFormData;
}): UpdateSuggestedAmountsToSaveInput[] =>
  getEnabledFrequencies(formData).flatMap((frequency) => {
    const isRecurrent = frequency.interval !== ProductDonationRecurrenceInterval.OneTime;
    if (formData.suggestedAmountsCount === 0) {
      return [{ amount: 0, isRecurrent, sortIndex: 0, recurrenceInterval: frequency.interval, message: null }];
    }
    return formData[frequency.amountsName].slice(0, formData.suggestedAmountsCount).map(
      (amount, index) =>
        ({
          amount: amount.amount,
          isRecurrent,
          sortIndex: index,
          recurrenceInterval: frequency.interval,
          message: formData.enableAmountLabels ? amount.message || "" : null,
        }) as UpdateSuggestedAmountsToSaveInput
    );
  });
